export default __webpack_public_path__ + "static/media/le_mont3.0d34c02b.jpg";